import axios from 'axios';

import type {
  IUserGetUniqueUsersRequest,
  IUserGetUniqueUsersQuery,
  IUserGetUniqueUsersResponse,
} from '@/app-package';

const getUniqueUsers = async (params: IUserGetUniqueUsersQuery) => {
  const config: IUserGetUniqueUsersRequest = {
    url: '/user/unique',
    method: 'get',
    params,
  };

  const { data } = await axios.request<IUserGetUniqueUsersResponse>(config);

  return data;
};

export default getUniqueUsers;
